/**
 * Shared delivery date rules for Bella cart drawer and pre-order PDP modal.
 *
 * Cart drawer:
 *   Dubai — same-day before 7:00 PM Asia/Dubai; after 7 PM earliest is tomorrow.
 *   Other Emirates — today is not selectable; earliest is 3 days from today.
 *
 * Pre-order PDP:
 *   Dubai — today + next 2 days disabled (earliest selectable is 3 days from today).
 *   Other Emirates — today + next 3 days disabled (earliest selectable is 4 days from today).
 */
(function () {
  const CUTOFF_HOUR = 19;
  const SHOP_TIMEZONE = 'Asia/Dubai';
  const CART_OTHER_LEAD_DAYS = 3;
  const PDP_DUBAI_LEAD_DAYS = 3;
  const PDP_OTHER_LEAD_DAYS = 4;

  function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  function addDays(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
  }

  /** Current date/time in the shop timezone (UAE), not the shopper's browser clock. */
  function nowInShopTz() {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: SHOP_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
      return new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'));
    } catch (e) {
      return new Date();
    }
  }

  function isoDate(d) {
    const x = new Date(d);
    const y = x.getFullYear();
    const m = String(x.getMonth() + 1).padStart(2, '0');
    const day = String(x.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function parseISODate(s) {
    if (!s) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  function getCartMinSelectableDate(region) {
    const now = nowInShopTz();
    const today = startOfDay(now);
    if (region === 'other') {
      return startOfDay(addDays(today, CART_OTHER_LEAD_DAYS));
    }
    if (now.getHours() >= CUTOFF_HOUR) {
      return startOfDay(addDays(today, 1));
    }
    return today;
  }

  function getPdpMinSelectableDate(region) {
    const today = startOfDay(new Date());
    if (region === 'other') {
      return startOfDay(addDays(today, PDP_OTHER_LEAD_DAYS));
    }
    return startOfDay(addDays(today, PDP_DUBAI_LEAD_DAYS));
  }

  /** @param {'cart'|'pdp'} [context] */
  function getMinSelectableDate(region, context) {
    if (context === 'pdp') return getPdpMinSelectableDate(region);
    return getCartMinSelectableDate(region);
  }

  /** @param {'cart'|'pdp'} [context] */
  function isBeforeMinSelectable(date, region, context) {
    const min = getMinSelectableDate(region, context);
    return startOfDay(date).getTime() < min.getTime();
  }

  function monthLabel(d, lang) {
    return d.toLocaleDateString(lang || document.documentElement.lang || undefined, {
      month: 'long',
      year: 'numeric',
    });
  }

  window.BellaDeliveryRules = {
    CUTOFF_HOUR,
    SHOP_TIMEZONE,
    CART_OTHER_LEAD_DAYS,
    PDP_DUBAI_LEAD_DAYS,
    PDP_OTHER_LEAD_DAYS,
    startOfDay,
    addDays,
    nowInShopTz,
    isoDate,
    parseISODate,
    getCartMinSelectableDate,
    getPdpMinSelectableDate,
    getMinSelectableDate,
    isBeforeMinSelectable,
    monthLabel,
  };
})();
